export default __webpack_public_path__ + "static/media/Logo_cran_noir.d0afe097.svg";